
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unicorn-tracker",
      function () {
        return require("private-next-pages/unicorn-tracker/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unicorn-tracker"])
      });
    }
  